import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SelectGroup from '../../../../shared/form/select-group';
import _ from 'underscore';

class Component extends BaseComponent {
    shouldComponentUpdate() {
        return false;
    }

    render({ cards, placeholder }) {
        if (cards && cards.length) {
            let options = {};
            _.map(cards, card => options[card.canonical_rank] = card.name);

            return (
                <tarot-card-selector onClick={this.trackClick}>
                    <SelectGroup
                        options={options}
                        default={placeholder || 'Search Any Tarot Card Meaning'}
                        onChange={this.handleChange}
                    />
                </tarot-card-selector>
            );
        }

        return (
            <tarot-card-selector>
                <select-group>
                    <select>
                        <option disabled value>
                            {placeholder || 'Search Any Tarot Card Meaning'}
                        </option>
                    </select>
                </select-group>
            </tarot-card-selector>
        );
    }

    handleChange = (e) => {
        document.location.href = `/tarot/cards/${e.target.value}`;
    }

    trackClick = () => {
        if (this.props.category && this.props.label) {
            this.props.trackEvent([
                this.props.category,
                this.props.logged_in ? 'LI Click' : 'LO Click',
                this.props.label,
            ]);
        }
    }
}

const mapStateToProps = (state) => ({
    cards: state.deck && state.deck.cards,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
